import React from 'react'
import { ThemeProvider } from '@mui/material/styles'
import { Provider as ReduxProvider } from 'react-redux'
import theme from './theme'
import AppRouter from './router/AppRouter'

export const Root = ({ history, store }) => (
    <ReduxProvider store={store}>
        <ThemeProvider theme={theme}>
            <AppRouter history={history} />
        </ThemeProvider>
    </ReduxProvider>
)

Root.displayName = 'Root'

export default Root
